// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-1419fc2f] {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.box-bubble[data-v-1419fc2f] {\n  border: 1px solid #cfcdcd;\n  padding: 10px;\n  border-radius: 10px;\n}\n.pm-template[data-v-1419fc2f] {\n  display: flex;\n  gap: 10px;\n}\n.pm-template-index[data-v-1419fc2f] {\n  flex: 1;\n}", ""]);
// Exports
module.exports = exports;
